import React, { useEffect } from 'react'
import EcxSidebar from './components/EcxSidebar'
import EcxHeader from './components/EcxHeader'
import EcxOffcanvas from './components/EcxOffcanvas'
import { Outlet, useLocation } from 'react-router-dom'
import { useEyeconxStore } from '../../store/eyeconxStore'
import clinicService from '../../services/clinic.service'

function MainLayout() {
  const location = useLocation()
  const user = useEyeconxStore(state => state.user)
  const userInfo = useEyeconxStore(state => state.userInfo)
  const setUserInfo = useEyeconxStore(state => state.setUserInfo)
  const sidebarCollapsed = useEyeconxStore((state) => state.sidebarCollapsed);
  const userPanelOpen = useEyeconxStore((state) => state.userPanelOpen)
  const setUserPanelOpen = useEyeconxStore((state) => state.setUserPanelOpen)
    const isFullWidthPage = ['/dashboard', '/messages', '/articles', '/eye-draw', '/my-files', '/pms-update-history', '/activity', '/invalid-details', '/appointments', '/reputation', '/web-bookings', '/update-password', '/help', '/settings/clinic', '/settings/features', '/settings/reminders', '/settings/users'].some((path) => location.pathname.endsWith(path))
        || location.pathname.startsWith('/patient-files')

  useEffect(() => {
    if (userInfo === null) {
      getUserInfo()
    }
  }, [])

  useEffect(() => {
    setUserPanelOpen(false)
  }, [location.pathname, setUserPanelOpen])

  const getUserInfo = () => {
    clinicService.getUserInfo(user.clinicId, user.ID)
      .then(res => {
        setUserInfo(res.data)
      })
      .catch(() => {})
  }

  return (
    <div className="d-flex ecx-layout" style={{ backgroundColor: '#fcfcfc' }}>
      <aside className={`ecx-sidebar d-none d-md-block ${sidebarCollapsed ? 'ecx-sidebar--collapsed' : ''}`}>
        <EcxSidebar collapsed={sidebarCollapsed} />
      </aside>

      <main className="ecx-main d-flex flex-column flex-grow-1 min-vh-100" style={{ minWidth: 0, height: '100vh', overflow: 'hidden' }}>
        <div className="flex-shrink-0" style={{ zIndex: 1000, backgroundColor: '#fff' }}>
          <EcxHeader />
        </div>

        <div className="ecx-main-content">
          <div className={isFullWidthPage ? 'h-100' : 'container-xxl h-100'}>
            <Outlet />
          </div>
        </div>
      </main>

      <EcxSidebar mobile collapsed={false} />
      <EcxOffcanvas show={userPanelOpen} handleClose={() => setUserPanelOpen(false)} />
    </div>
  )
}

export default MainLayout
